import basicTheme from '../basicTheme.js';

const MuiLinearProgressStyleOverrides = {
    styleOverrides: {
        root: {
            backgroundColor: basicTheme.palette.N40.main,
            borderRadius: '4px',
            height: '2px',
        },
        bar: {
            transform: `translateX(0%) !important`,
            transition: `all ${basicTheme.transitions.duration.fast} linear`,
            borderRadius: '4px',
            height: '2px',
        },
    },
};

export { MuiLinearProgressStyleOverrides as default };
//# sourceMappingURL=MuiLinearProgress .js.map
